export default __webpack_public_path__ + "4cb8634719af11ab3dfbec2fa8ef9760.png";